<template>
  <table class="b2b-grid b2b-grid--collapse mb-0">
    <thead class="b2b-grid__header">

      <!-- Each Header -->
      <tr>
        <th v-for="(header, index) in localGridData.header"
          :key="index"
          :data-type="`${header.type}`"
          :class="[widthClass, header.cssClass]"
          class="b2b-grid__cell b2b-grid__head">
          <grid-checkbox v-if="header.type === 'input-checkbox'"></grid-checkbox>
          <template v-else>
            {{ header.label }}
          </template>
        </th>
      </tr>

    </thead>
    <tbody>
      <!-- Each Row -->
      <template v-for="(row, rowIndex) in localGridData.row">
        <grid-item
          :row="row"
          :row-data="row.data"
          :row-id="row.id"
          :key="`row-${row.id}`"
          :class="[
            { 'bg-gray-02': (rowIndex+1) % 2 === 0 },
            { 'is-expanded': row.expanded },
          ]">

          <!-- Each Cell -->
          <td v-for="(cellData, dataIndex) in row.data"
            class="b2b-grid__cell lg:table-cell"
            :data-type="`${cellData.type}`"
            :class="[
              dataIndex,
              cellData.cssClass,
              { 'mb-4 md:mb-0' : dataIndex + 1 === row.data.length }
            ]"
            :key="`cell-${dataIndex}`">

            <div class="b2b-grid__label">
              {{ localGridData.header[dataIndex].label }}
            </div>

            <div class="b2b-grid__content">
              <grid-icon v-if="cellData.type === 'icon'" :data="cellData"></grid-icon>

              <grid-note v-else-if="cellData.type === 'note'"
                :data="cellData"
                :row-id="row.id">
              </grid-note>


              <grid-warehouse v-else-if="cellData.type === 'warehouse'"
                :value="cellData.value"
                :level="cellData.level"
                :etaLabel="cellData.etaLabel">
              </grid-warehouse>
              <grid-stock-watch v-else-if="cellData.type === 'stock-watch'"
                :warehouses="cellData.items">
              </grid-stock-watch>
              <grid-price v-else-if="cellData.type === 'price'" :data="cellData.value"></grid-price>
              <grid-checkbox v-else-if="cellData.type === 'input-checkbox'" :data="cellData" :row-id="row.id"></grid-checkbox>
              <grid-input v-else-if="cellData.type.startsWith('input-')" :data="cellData"></grid-input>
              <grid-switch v-else-if="cellData.type === 'toggle-switch'" :data="cellData"></grid-switch>
              <div v-else-if="cellData.type === 'expand'">
                <i class="b2b-grid__icon material-icons"
                  @click="expandRow(rowIndex)"
                  ref="">
                  {{ row.expanded ? 'indeterminate_check_box' : 'add_box' }}
                </i>
              </div>
              <grid-text v-else :data="cellData"></grid-text>
            </div>
          </td>

        </grid-item>

        <transition v-if="row.childData" name="fade" :key="`child-${row.id}`" >
          <tr v-show="row.expanded"
            class="table-row table-row--child"
            :class="{ 'is-expanded': row.expanded }">
            <td v-if="row.data" class="px-2" :colspan="row.data.length">
              <slot name="child" :row="row"></slot>
            </td>
          </tr>
        </transition>

      </template>
    </tbody>
  </table>
</template>

<script>

export default {
  props: {
    gridData: Object
  },
  data() {
    return {
      localGridData: this.gridData,
    }
  },
  computed: {
    widthClass() {
      if(this.localGridData.header.size) {
        return `w-${localGridData.header.size}`;
      }
      return '';
    },
  },
  methods: {
    expandRow(rowIndex) {
      console.log(`expandRow(${rowIndex})`);
      this.localGridData.row[rowIndex].expanded = !this.localGridData.row[rowIndex].expanded;
    }
  }
};
</script>
